import { SCAN_SOUND_OPTIONS, DEFAULT_SCAN_SOUND_ID } from './scanSoundOptions';
import { useScanSoundSettingsStore } from '../../store/scanSoundSettingsStore';
import { isIOS } from '../deviceUtils';

// iOS 共享实例池
const sharedAudioMap = new Map<string, HTMLAudioElement>();

export const playEnqueuedScanSound = async (soundId?: string): Promise<void> => {
  const resolvedId = soundId ?? useScanSoundSettingsStore.getState().selectedSoundId;
  const option = SCAN_SOUND_OPTIONS.find(o => o.id === resolvedId)
    ?? SCAN_SOUND_OPTIONS.find(o => o.id === DEFAULT_SCAN_SOUND_ID);

  if (!option) return;

  const src = option.src;

  if (isIOS()) {
    try {
      let audio = sharedAudioMap.get(option.id);
      if (!audio) {
        audio = new Audio(src);
        audio.load();
        sharedAudioMap.set(option.id, audio);
      } else {
        audio.currentTime = 0;
      }
      void audio.play().catch(err => {
        console.error('[scanSoundUtils] iOS 播放失败:', err);
      });
    } catch (err) {
      console.error('[scanSoundUtils] iOS 音频异常:', err);
    }
    return;
  }

  const audio = new Audio(src);
  return audio.play().catch(err => {
    console.error('[scanSoundUtils] 播放失败:', err);
  });
};
